export default function useSearchHelpers() {
  const getLocationName = (isGlobalUser, licenseRegion, licenseCountry) => {
    if (isGlobalUser && ['CA', 'US'].includes(licenseCountry)) {
      return licenseCountry === 'CA' ? 'Canada' : 'US';
    }

    return licenseRegion;
  };

  return { getLocationName };
}
